import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface MSPState {
  selectedMspId: number | null
}

const initialState: MSPState = {
  selectedMspId: null
}

const mspSlice = createSlice({
  name: 'selectedMsp',
  initialState,
  reducers: {
    setSelectedMspId: (state, action: PayloadAction<number>) => {
      state.selectedMspId = action.payload
    },
    clearSelectedMspId: (state) => {
      state.selectedMspId = null
    }
  }
})

export const { setSelectedMspId, clearSelectedMspId } = mspSlice.actions
export default mspSlice.reducer
